// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ssqw","colBig":"styles_colBig__3-8ck","colSmall":"styles_colSmall__3ZAug"};